import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useMutation, useClient } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
import queryDocumentNodeId from './query-document-node-id.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)
  let client = useClient()

  let patient_id = useDataValue({
    context: 'patient',
    viewPath: props.viewPath,
    path: '_id',
  })

  let letter = useDataValue({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let changeLetter = useDataChange({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let letterParams = useDataValue({
    context: 'modal',
    path: 'letter_params',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ args, value, change }) {
    switch (args.type) {
      case 'edit_letter': {
        try {
          if (!letter.document_node_id) {
            change(next => {
              next.loading = true
            })

            let response = await executeMutation({
              patient_id,
              document_template_id: letter.document_template_id,
              recipient_id: letter.recipient_id,
              postal_address_id: null,
              tooth_chart_snapshot_id: letter.tooth_chart_snapshot_id,
              tooth_marking_ids: letter.tooth_marking_ids,
              diagnosis_id: letter.diagnosis_id,
              ...letterParams,
            })

            if (response.error) {
              notify(notifyError('Error while generating letter.'))
              return
            }

            let {
              data: { vaxiom_document_tree_nodes },
            } = await client
              .query(queryDocumentNodeId, {
                _id: response.data.tasks_generate_letter.documentNodeId,
              })
              .toPromise()

            changeLetter(next => {
              next.document_node_id = vaxiom_document_tree_nodes?.[0]?.id
              next.document_node__id =
                response.data.tasks_generate_letter.documentNodeId
            })
          }

          setFlowTo(normalizePath(props.viewPath, 'EditLetterModal/Content'))
        } finally {
          change(next => {
            next.loading = false
          })
        }

        break
      }

      case 'tab/openCommsThread': {
        change(next => {
          let comms = next.comms

          comms.thread_id = args.thread_id
          comms.is_secure =
            typeof args.is_secure === 'boolean' ? args.is_secure : true
          comms.auto_uploaded_attachments = args.auto_uploaded_attachments || []
          comms.message = args.message || ''
          comms.tags = args.tags || []
          comms.is_blocking = !!args.is_blocking

          if (args.thread_id in comms.message_composes) {
            let messageCompose = comms.message_composes[args.thread_id]
            messageCompose.is_secure = comms.is_secure
            messageCompose.message = comms.message

            if (Array.isArray(messageCompose.auto_uploaded_attachments)) {
              messageCompose.auto_uploaded_attachments = [
                ...messageCompose.auto_uploaded_attachments,
                ...comms.auto_uploaded_attachments,
              ]
            } else {
              messageCompose.auto_uploaded_attachments =
                comms.auto_uploaded_attachments
            }

            if (Array.isArray(messageCompose.tags)) {
              messageCompose.tags = [...messageCompose.tags, ...comms.tags]
            } else {
              messageCompose.tags = comms.tags
            }
          }
        })

        break
      }

      default:
    }
  }
}
